import { createSelector } from 'reselect';

import { getLang } from '../../../../i18n/l10n';
import type { SelectorMaker, Selector } from '../../../../types/selectors';
import { GRAssetsBySkinId } from '../../constants/assets';
import { selectGRGlobalSkinId, selectGRGlobalStartDate } from '../../selectors/global/globalPrimary.selector';

type GRBannerPropsType = {
  backgroundPath: string;
  showCountdown?: boolean;
};

const makeSelectGRBannerPropsSelector: SelectorMaker<GRBannerPropsType> = () => {
  const selectBackgroundPath: Selector<string> = createSelector([selectGRGlobalSkinId], (skinId) =>
    skinId ? GRAssetsBySkinId[skinId]?.Banners[getLang()] : '',
  );

  return createSelector([selectBackgroundPath, selectGRGlobalStartDate], (backgroundPath, startDate) => ({
    backgroundPath,
    showCountdown: new Date().getTime() >= (startDate ?? 0),
  }));
};

export default makeSelectGRBannerPropsSelector;
